import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import { useCheckListViewModel } from "../../viewModels/checklist_lista_view_model";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateProjetoColumnDefinition } from "./columns";
import { useMemo } from "react";
import { ModalChecklistLista } from "./components/modal_create";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ChecklistLista } from "../../../domain/models/checklist_Lista";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

export const Checklist_Lista = () => {
  const viewModel = useCheckListViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateProjetoColumnDefinition({
      onActionEditar: viewModel.handleModalOpenState,
      onActionDeletar: viewModel.DeleteOpenModal,
      onActionViewItem: viewModel.handleViewChecklist,
    });
  }, [viewModel.DeleteOpenModal, viewModel.handleModalOpenState, viewModel.handleViewChecklist]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={() => viewModel.handleModalOpenState(null, true)}
              >
                Novo Item
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Projetos
          </Link>
          <Typography className="text-primary-green">Lista de Checklist</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Checklist</h1>
          <RefreshButton onClick={viewModel.handleReload} />
        </div>

        <Header nome={viewModel.filters.nome}
          onNome={viewModel.handleNomeChange}
          onClear={viewModel.handleClearFilters}
          handleStatus={viewModel.handleStatusoChange}
          status={viewModel.filters.status} />

        <StyledDataGrid
          tableName="Checklist Lista"
          disableColumnMenu={false}
          showToolbar={true}
          disableRowSelectionOnClick={true}
          getRowId={(row: ChecklistLista) => row.IdChecklist}
          columns={columnsDefinition}
          loading={viewModel.loading}
          checkboxSelection={false}
          rows={viewModel.checklistLista}
          rowCount={viewModel.checklistLista.length}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
          paginationModel={{
            page: viewModel.pagination.page,
            pageSize: viewModel.pagination.rowsPerPage,
          }}
          pinnedColumns={{
            right: ["IdChecklist"],
          }}
        />
        <TablePagination
          component="div"
          count={viewModel.pagination.totalItems}
          page={viewModel.pagination.page - 1}
          onPageChange={(_, p) => viewModel.handlePageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={viewModel.pagination.rowsPerPage}
          onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
        />
      </div>

      <ModalChecklistLista
        open={viewModel.checklistModal}
        saving={viewModel.saving}
        onClose={() => viewModel.setChecklistModal(false)}
        onSubmit={viewModel.handleCheckListSubmit}
        selectedChecklist={viewModel.selectedChecklist}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.DeleteOpenModal(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarCheckList}
      />
    </>
  );
};
